import { IApproval, ICompliance } from '@/types/tasksApprovals'

import ApprovalsList from './approvals'
import TasksList from './tasks'

interface IProps {
    items: IApproval[] | ICompliance[]
    type: 'approvals' | 'tasks'
}

const ItemsList = ({ items, type }: IProps) => {
    let approvals: IApproval[] = []
    let tasks: ICompliance[] = []

    if (type === 'approvals') {
        approvals = Array.from([...items]) as IApproval[]
    }

    if (type === 'tasks') {
        tasks = Array.from([...items]) as ICompliance[]
    }

    return (
        <>
            {type === 'approvals' && <ApprovalsList approvals={approvals} />}
            {type === 'tasks' && <TasksList tasks={tasks} />}
        </>
    )
}

export default ItemsList
